export const allTableItems = [
  { label: "アクセスユーザー数", value: "uniqueUserCount" },
  { label: "CV人数", value: "cvUserCount" },
  { label: "CVR", value: "cvr" },
  { label: "平均滞在時間", value: "averageStayTime" },
  { label: "読了率", value: "scrollRate" },
];

export const initialSelectedTableItems = allTableItems;
